interface ActionButtonsProps {
  selectedLineIndex: number | null;
  onTender: () => void;
  onReturn: () => void;
  onSupervisorAction: (action: string) => void;
  onPrint: () => void;
  onParkSale: () => void;
  onRecall: () => void;
  hasParkedSales?: boolean;
  onOrderDiscount: () => void;
  orderDiscountDisabled?: boolean;
  onCancelTransaction: () => void;
  onExchange: () => void;
  tenderDisabled?: boolean;
  // Return mode
  returnMode?: boolean;
  returnProcessed?: boolean;
  isProcessingReturn?: boolean;
  returnInProgress?: boolean;
  onRefund?: () => void;
  onExchangeAction?: () => void;
  refundAllowed?: boolean;
}

export default function ActionButtons({
  selectedLineIndex,
  onTender,
  onReturn,
  onSupervisorAction,
  onPrint,
  onParkSale,
  onRecall,
  hasParkedSales = false,
  onOrderDiscount,
  orderDiscountDisabled = false,
  onCancelTransaction,
  onExchange,
  tenderDisabled = false,
  returnMode = false,
  returnProcessed = false,
  isProcessingReturn = false,
  returnInProgress = false,
  onRefund,
  onExchangeAction,
  refundAllowed = false,
}: ActionButtonsProps) {
  return (
    <div className="flex-1 bg-white border-l border-gray-200 p-3 overflow-y-auto">
      <div>
        <h3 className="text-xs font-bold text-gray-700 mb-1.5 whitespace-nowrap">Primary Actions</h3>
        <div className="space-y-1.5">
          {/* Make Payment — hidden while return is pending, visible when processed or normal mode */}
          {(!returnMode || returnProcessed) && (
            <button
              onClick={onTender}
              disabled={tenderDisabled}
              className="w-full px-4 py-3 bg-teal-600 hover:bg-teal-700 text-white rounded-lg font-bold text-base whitespace-nowrap transition-colors cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
            >
              <i className="ri-money-dollar-circle-line mr-2 text-xl"></i>
              Make Payment
            </button>
          )}

          {/* Refund + Exchange — shown while return is pending */}
          {returnMode && !returnProcessed && (
            <div className={`grid gap-2 ${refundAllowed ? 'grid-cols-2' : 'grid-cols-1'}`}>
              {refundAllowed && (
                <button
                  onClick={onRefund}
                  disabled={isProcessingReturn}
                  className="px-3 py-3 bg-sky-500 hover:bg-sky-600 text-white rounded-lg font-bold text-sm whitespace-nowrap transition-colors cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  <i className="ri-refund-2-line mr-1 text-base"></i>
                  Refund
                </button>
              )}
              <button
                onClick={onExchangeAction}
                disabled={isProcessingReturn}
                className="px-3 py-3 bg-teal-500 hover:bg-teal-600 text-white rounded-lg font-bold text-sm whitespace-nowrap transition-colors cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {isProcessingReturn ? (
                  <><i className="ri-loader-4-line animate-spin mr-1"></i>Processing...</>
                ) : (
                  <><i className="ri-exchange-line mr-1 text-base"></i>Exchange</>
                )}
              </button>
            </div>
          )}
        </div>
      </div>

      <div className="mt-3">
        <h3 className="text-xs font-bold text-gray-700 mb-1.5 whitespace-nowrap">Transaction Actions</h3>
        <div className="space-y-1.5">
          <button
            onClick={onOrderDiscount}
            disabled={orderDiscountDisabled}
            className="w-full px-3 py-2 bg-orange-500 hover:bg-orange-600 text-white rounded-lg text-sm font-semibold whitespace-nowrap transition-colors cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
          >
            <i className="ri-discount-percent-line mr-1"></i>
            Order Discount
          </button>

          <div className="grid grid-cols-2 gap-1.5">
            <button
              onClick={onParkSale}
              className="px-3 py-2 bg-indigo-500 hover:bg-indigo-600 text-white rounded-lg text-sm font-semibold whitespace-nowrap transition-colors cursor-pointer"
            >
              <i className="ri-save-line mr-1"></i>
              Park Sale
            </button>
            <button
              onClick={onRecall}
              disabled={!hasParkedSales}
              className="px-3 py-2 bg-indigo-500 hover:bg-indigo-600 text-white rounded-lg text-sm font-semibold whitespace-nowrap transition-colors cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
            >
              <i className="ri-inbox-unarchive-line mr-1"></i>
              Recall
            </button>
          </div>

          <button
            onClick={onExchange}
            disabled={returnInProgress}
            className="w-full px-3 py-2 bg-teal-500 hover:bg-teal-600 text-white rounded-lg text-sm font-semibold whitespace-nowrap transition-colors cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
          >
            <i className="ri-arrow-go-back-line mr-1"></i>
            Return
          </button>

          <button
            onClick={onCancelTransaction}
            className="w-full px-3 py-2 bg-red-600 hover:bg-red-700 text-white rounded-lg text-sm font-semibold whitespace-nowrap transition-colors cursor-pointer"
          >
            <i className="ri-close-circle-line mr-1"></i>
            Cancel Transaction
          </button>
        </div>
      </div>
    </div>
  );
}
